import React, { useState } from 'react';
import styles from './photos.module.css';
import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined';
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import AttachmentThumb from '../../../../../components/patient-attachments/AttachmentThumb';
import AttachmentViewerPopup from '../../../../../components/patient-attachments/AttachmentViewerPopup';
import { CRANIAL_PHOTO_VIEWS } from './cranialPhotoViews';

const THUMB_SIZE = 44;
const MAX_THUMBS = 3;

/**
 * Célula "Fotos" de uma medição, na tabela do desktop e nos cards do celular:
 * as miniaturas empilhadas (até 3 + "+N") e o atalho para adicionar, sempre
 * um ícone compacto para não alargar a linha.
 */
const CranialPhotoCell = ({ photos, enabled, onAdd, onChanged }) => {
    const [selected, setSelected] = useState(null);

    const list = photos || [];
    const shown = list.slice(0, MAX_THUMBS);
    const remaining = list.length - shown.length;

    function viewerHideHandler(changed) {
        setSelected(null);

        if (changed && onChanged) onChanged();
    }

    if (list.length === 0 && !enabled) {
        return <span className={styles.cellEmpty}>—</span>;
    }

    return (
        <div className={styles.cell}>
            {shown.map((photo) => (
                <AttachmentThumb
                    key={photo.id}
                    attachment={photo}
                    size={THUMB_SIZE}
                    onClick={() => setSelected(photo)}
                />
            ))}

            {remaining > 0 && (
                <div
                    className={styles.cellMore}
                    onClick={() => setSelected(list[MAX_THUMBS])}
                    title={`Mais ${remaining} foto(s)`}
                >
                    {`+${remaining}`}
                </div>
            )}

            {enabled && (
                <div
                    className={styles.cellMore}
                    onClick={onAdd}
                    title="Adicionar fotos"
                    aria-label="Adicionar fotos"
                    role="button"
                >
                    {list.length === 0
                        ? <PhotoCameraOutlinedIcon fontSize="small" />
                        : <AddPhotoAlternateOutlinedIcon fontSize="small" />}
                </div>
            )}

            {selected && (
                <AttachmentViewerPopup
                    attachment={selected}
                    list={list}
                    enabled={enabled}
                    viewOptions={CRANIAL_PHOTO_VIEWS}
                    OnHide={viewerHideHandler}
                />
            )}
        </div>
    );
};

export default CranialPhotoCell;
